<svelte:options accessors={true}/>
<script>
	import Search from './sorting/Search.svelte';
	import EntriesSelector from './sorting/EntriesSelector.svelte';
  import { createEventDispatcher } from 'svelte';
	import CellsMenu from './CellsMenu.svelte';
  import AuthService from '../services/auth.service.js';
  export let component;
  const dispatch = createEventDispatcher();
  let loadingExport = false;
  const ableTo = {
    export: ['Weekly', 'Monthly', 'Employees', 'Sdr', 'StaffingDashboard', 'Candidates', 'Census', 'Plans', 'Staff', 'Individual'],
    add_section: ['Weekly', 'Monthly', 'Employees', 'Individual'],
    add_row: ['Candidates', 'Census', 'Staff'],
    remove_indicator: ['Weekly', 'Monthly', 'Sdr', 'Individual'],
    import: ['Candidates', 'Census', 'Plans', 'Staff'],
    show_entries: ['Candidates', 'Census', 'Staff']
  };

  const IS_OPERATIONS_KPIS = ENVIRONMENT.IS_OPERATIONS_KPIS;

  let exportReport = function(allPortcos = false) {
    loadingExport = true;
    const verifyExport = setInterval(() => {
      if(component && !component.loadingExport){
        loadingExport = false;
        clearInterval(verifyExport);
      }
    }, 100);
		dispatch('exportReport', {all_portcos: allPortcos});
  }
  function changeExportStatus(){
    console.log(component);
  }
  let indicatorsRemoved = function(response) {
		dispatch('indicatorsRemoved', true);
  }

  let addSection = function(response) {
		dispatch('addSection', true);
  }

  // HR
  let importModal = function(response) {
		dispatch('importModal', true);
  }

  let addRow = function(response) {
		dispatch('addRow', true);
  }

  let selectEntries = function(entries) {
		dispatch('selectEntries', {entries: entries});
  }

  let search = function(searchText) {
		dispatch('search', {search: searchText});
  }
</script>
<div class="row mb-2">
  {#if component && ableTo.show_entries.includes(component.constructor.name)}
    <EntriesSelector on:change={(e) => selectEntries(e.detail.entries)} class="pl-2" />
    <Search on:change={(e) => search(e.detail.search)} />
  {/if}
  <div class="pr-3 {(component && component.constructor.name == 'Weekly')? 'text-center ' : ''} {component && ableTo.show_entries.includes(component.constructor.name)?' text-right col-4 offset-3' : 'col-12'}">
    {#if component && component.constructor.name == 'Weekly'}
      <h5 id="week-ending-text">Week Ending</h5>
    {/if}
    {#if component && ableTo.export.includes(component.constructor.name)}
      {#if component.constructor.name == 'Employees' && AuthService.can('EXPORT_HR_ALL_PORTCOS')}
        <div class="dropdown float-right mr-2">
          <button class="btn btn-sm btn-primary ml-2 float-right" disabled={loadingExport}>
            <i class={loadingExport? 'fa fa-circle-o-notch fa-spin':'fa fa-file-excel-o'} aria-hidden="true"></i>
            Export
          </button>

          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li on:click={() => exportReport(false)} class="dropdown-item">
                  Selected Company
              </li>

              <li on:click={() => exportReport(true)} class="dropdown-item">
                  All Companies
              </li>
          </ul>
        </div>
      {:else}
        <button id="export-btn" on:click={() => exportReport(false)} class="btn btn-sm btn-primary ml-2 float-right" disabled={loadingExport}>
          <i class={loadingExport? 'fa fa-circle-o-notch fa-spin':'fa fa-file-excel-o'} aria-hidden="true"></i>
          Export
        </button>
      {/if}
    {/if}
    {#if component && ableTo.add_section.includes(component.constructor.name) && ( IS_OPERATIONS_KPIS && component.constructor.name !== 'Monthly')}
      <button  on:click={addSection} class="btn btn-sm btn-primary float-right">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Add 
          { IS_OPERATIONS_KPIS && component.constructor.name === 'Individual' ? 'Role' : 'Section'}
      </button>
    {/if}
    {#if component && ableTo.remove_indicator.includes(component.constructor.name)}
      <CellsMenu 
        isIndividual={component.constructor.name === 'Individual'} on:indicatorsRemoved={indicatorsRemoved}>
      </CellsMenu>
    {/if}
    <!-- HR -->
    {#if component && ableTo.add_row.includes(component.constructor.name)}
      {#if AuthService.can('ADD_CANDIDATE')}
        <button class="btn btn-primary btn-sm text-light"
          on:click={addRow}>
          <i class="fa fa-plus"></i>
          Add
          {#if component && component.constructor.name == 'Candidates'}
            Candidate
          {:else if  component && component.constructor.name == 'Census'}
            <!-- Termination Census -->
            Position
          {:else if  component && component.constructor.name == 'Staff'}
          <!-- Open Positions report-->
            Open Position
          {/if}
        </button>
      {/if}
    {/if}
    {#if component && ableTo.import.includes(component.constructor.name)}
      {#if AuthService.can('IMPORT_HR_REPORTS') }
        <button class="btn btn-success btn-sm text-light {(component && component.constructor.name == 'Plans')? 'float-right' : ''}"
            on:click={importModal}>
            <i class="fa fa-upload"></i>
            Import
        </button>
      {/if}
    {/if}
  </div>
</div>